import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Elogin from "pages/Authentication/Elogin"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import QuotesOrders from "../pages/Quotes/index"
import OrdersOrders from "../pages/Orders/index"
import VectorsOrders from "../pages/Vectors/index"
import Customers from "pages/Customers"
import Reports from "pages/Reports"
import Employee from "pages/Employee"
import UserDashboard from "pages/Users/Dashboard"
import UserOrders from "pages/Users/orders/ordersForm"
import ViewRecords from "pages/Users/orders"
import PaymentInvoice from "pages/publicFiles/invoice"
import GenerateInvoice from "pages/Users/Invoice"
import InvoiceHistory from "pages/Users/Invoice/invoiceHistory"
// import CalibrationChart from "pages/Users/test"


const authProtectedRoutes = [
  //user
  // rjk321
  // rox12345
  { path: "/user/dashboard", component: UserDashboard , roles: ["User"] },
  // {path: "/user/test", component: CalibrationChart, roles: ["User"]},
  { path: "/user/create-order", component: UserOrders , roles: ["User"] },
  { path: "/user/create-quote", component: UserOrders , roles: ["User"] },
  { path: "/user/create-vector", component: UserOrders , roles: ["User"] },
  { path: "/user/view-orders", component: ViewRecords , roles: ["User"] },
  { path: "/user/view-quotes", component: ViewRecords , roles: ["User"] },
  { path: "/user/view-vectors", component: ViewRecords , roles: ["User"] },
  { path: "/user/invoice-history", component:  InvoiceHistory, roles: ["User"] },
  { path: "/user/generate-invoice", component: GenerateInvoice , roles: ["User"] },
  

  //admin
  { path: "/dashboard", component: Dashboard , roles: ["Administrate","sales" ] },
  { path: "/vector/todays-vectors", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/vector/ready-vectors", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/vector/all-vectors", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/vector/vector-with-price-zero", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/vector/vector-with-price", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/order/orders-with-price", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/order/orders-with-price-zero", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/order/ready-orders", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/order/todays-orders", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/order/all-orders", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/quote/convert-to-order", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/quote/todays-quotes", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/quote/ready-quotes", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/quote/all-quotes", component:  OrdersOrders, roles: ["Administrate"] },
  { path: "/customers", component:  Customers, roles: ["Administrate","sales"] },
  { path: "/all-customers", component:  Customers, roles: ["Administrate"] },
  { path: "/sales-man-progress", component:  Reports, roles: ["Administrate","sales"] },
  { path: "/orders-report", component:  Reports, roles: ["Administrate"] },
  { path: "/customers-report", component:  Reports, roles: ["Administrate"] },
  { path: "/company-report", component:  Reports, roles: ["Administrate"] },
  { path: "/employee", component:  Employee, roles: ["Administrate"] },
  { path: "/designers-progress", component:  Reports, roles: ["Administrate"] },
  // Debra
  // Debra556688




  { path: "/profile", component: UserProfile , roles: ["Administrate"]},

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  {path: "/invoice/:id", component: PaymentInvoice}
]

export { publicRoutes, authProtectedRoutes }
